import React from 'react';
import { useQuery, gql } from '@apollo/client';
import ReactMarkdown from 'react-markdown';
import LegalPageLayout from '@/components/layout/LegalPageLayout';
import { useTranslation } from '@/hooks/useTranslation';
import { NAMESPACES } from '@/i18n/namespaces';

const GET_PRIVACY_POLICY = gql`
  query GetPrivacyPolicy {
    legal(type: PRIVACY_POLICY) {
      id
      title
      content
      created_at
      updated_at
    }
  }
`;

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation(NAMESPACES.LEGAL);
  const { data, loading } = useQuery(GET_PRIVACY_POLICY);
  
  const title = data?.legal?.title || t('privacyPolicy.title');
  const content = data?.legal?.content;
  const updatedAt = data?.legal?.updated_at ? new Date(data.legal.updated_at).toLocaleDateString() : 'June 1, 2023';
  
  return (
    <LegalPageLayout title={title} isLoading={loading}>
      {!loading && (
        <>
          {content ? (
            <div className="markdown-content">
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          ) : (
            <>
              <p className="mb-4">
                This is a placeholder for the Privacy Policy page. This content will be updated with actual privacy policy information.
              </p>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">Information We Collect</h3>
                <p className="mb-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis eget urna ultricies fermentum. 
                  Cras euismod, nisl vitae ultricies ultricies, nisl nisl ultricies nisl, nec ultricies nisl nisl nec.
                </p>
                <p>
                  Phasellus ac dolor vel felis feugiat aliquam. Integer ac lorem vel nisl venenatis ultricies. 
                  Suspendisse potenti. In hac habitasse platea dictumst.
                </p>
              </section>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">How We Use Your Information</h3>
                <p className="mb-3">
                  Nulla facilisi. Sed euismod, nisl vitae ultricies ultricies, nisl nisl ultricies nisl, 
                  nec ultricies nisl nisl nec. Phasellus ac dolor vel felis feugiat aliquam.
                </p>
                <ul className="list-disc pl-5 mb-3">
                  <li className="mb-1">To provide and maintain our service</li>
                  <li className="mb-1">To notify you about changes to our service</li>
                  <li className="mb-1">To allow you to participate in interactive features</li>
                  <li className="mb-1">To provide customer support</li>
                  <li>To monitor the usage of our service</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h3 className="text-xl font-bold mb-3">Last Updated</h3>
                <p>This Privacy Policy was last updated on {updatedAt}.</p>
              </section>
            </>
          )}
        </>
      )}
    </LegalPageLayout>
  );
};

export default PrivacyPolicy; 